// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_input-text_btn-primary__1sl_3","container":"_input-text_container__3kUG3","label":"_input-text_label__1E7lD","input":"_input-text_input__2E1nX"};